module.exports = __webpack_public_path__ + "img/taketomi_3.22eb32e5.jpg";